module.exports = __webpack_public_path__ + "img/diapositiva-4-1.285e6bf9.png";